<template>
  <div class="text-right text-sm gray-700">
    <div class="mt-3">
      <span class="bold">عنوان:</span> {{ this.exam.title }}
    </div>
    <div class="mt-3">
      <span class="bold"> نام درس:</span>
      <span v-for="course in exam.courses" :key="course.id"
      >{{ course.name }} {{ course.klass.grade.name }} {{ course.klass.name }}<span
          v-if="exam.courses.length > 1">، </span>
      </span>
    </div>
    <div class="mt-3">
      <span class="bold">بارم کل:</span> {{ this.exam.totalMark }}
    </div>
    <div class="mt-3">
      <span class="bold">تاریخ:</span> {{ startDate }}
    </div>
    <div v-if="exam.startTime" class="mt-3">
      <span class="bold"> ساعت:</span> {{ exam.endTime }} -
      {{ exam.startTime }}
    </div>
    <div
        v-show="
        (exam.status === 'FINISHED' && $type === 'TEACHER') || !exam.online
      "
        class="mt-3"
    >
      <span class="bold"> میانگین کلاس:</span> {{ exam.averageMark }}
    </div>
    <div
        v-show="
        (exam.status === 'FINISHED' && $type === 'TEACHER') || !exam.online
      "
        class="mt-3"
    >
      <span class="bold"> پایین ترین نمره کلاس:</span> {{ exam.minMark }}
    </div>
    <div
        v-show="
        (exam.status === 'FINISHED' && $type === 'TEACHER') || !exam.online
      "
        class="mt-3"
    >
      <span class="bold"> بالاترین نمره کلاس:</span> {{ exam.maxMark }}
    </div>
    <div
        v-if="
        (exam.status === 'FINISHED' && exam.type === 'MULTI_CHOICES') || !exam.online
      "
        class="mt-3"
    >
      <span class="bold">ضریب پایایی:</span> {{ exam.payaee }}
    </div>
  </div>

</template>

<script>
export default {
  props: {
    exam: {
      type: Object,
    },
  },
  computed: {
    startDate() {
      return this.exam.startDate.split("-").join("/");
    },
  },
};
</script>

<style lang="scss" scoped></style>